<template>
<div>
  <label>{{ $t('filters.inappropriate') }}</label>
  <v-radio-group
    :row="true"
    v-model="val"
    @change="changeValue"
  >
    <v-radio :label="$t('filters.hide')" value="hide"/>
    <v-radio :label="$t('filters.show')" value="show"/>
    <v-radio :label="$t('filters.only')" value="only"/>
  </v-radio-group>
</div>
</template>

<script>
export default {
  props: {
    value: String
  },
  data () {
    return {
      val: this.value
    }
  },
  methods: {
    changeValue () {
      this.$emit('input', this.val)
      this.$emit('change', this.val)
    }
  }
}
</script>
